import { utils, writeFile } from 'xlsx';

const exportCsv = async (...args) => {
  const params =
    typeof args[0] === 'string'
      ? {
          title: args[0],
          data: args[1],
          t: args[2],
          branding: args[3] || {},
        }
      : args[0] || {};

  const { title, data = [], t, branding = {} } = params;
  if (!Array.isArray(data) || data.length === 0) {
    const message = t ? t('reportNoData') : 'No data available'; // t(...) informa ausência de dados respeitando o idioma atual
    console.warn(message);
    return;
  }

  const sheetName = title;
  const wb = utils.book_new();

  const metaRows = [];
  if (branding.header?.title) metaRows.push([branding.header.title]);
  if (branding.header?.subtitle) metaRows.push([branding.header.subtitle]);
  if (branding.header?.generatedOn) metaRows.push([branding.header.generatedOn]);
  metaRows.push([]);

  const headers = Object.keys(data[0] || {});
  const ws = utils.aoa_to_sheet(metaRows);
  utils.sheet_add_json(ws, data, { origin: -1, header: headers });

  utils.book_append_sheet(wb, ws, sheetName);
  writeFile(wb, `${title}.csv`);
};

export default exportCsv;
